module.exports = __webpack_public_path__ + "img/96.3.TP.0a6bde55.png";